<!-- #166 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 mt-4"
        style="color: #23468c; font-weight: 500"
      >
        Upload Pincode
      </div>
      <v-spacer></v-spacer>
      <v-col cols="12" md="6" class="d-flex justify-end pt-0">
        <div class="d-flex">
          <v-dialog
            v-model="dialog"
            max-width="550px"
            @keydown.esc="dialog = false"
          >
            <v-card>
              <v-card-title>
                <span class="headline">Pincode Upload</span>
              </v-card-title>
              <v-divider class="mb-4"></v-divider>
              <v-card-text>
                <v-form ref="form" lazy-validation>
                  <v-row>
                    <v-col>
                      <v-file-input
                        v-model="file"
                        counter
                        show-size
                        accept=".xlsx"
                        outlined
                        label="Select your Excel file"
                        prepend-icon=""
                        prepend-inner-icon="mdi-paperclip"
                        :rules="[(v) => !!v || 'Please select Excel File']"
                      >
                      </v-file-input>
                      <v-btn
                        color="primary"
                        dark
                        class="mt-3"
                        :loading="fileLoader"
                        @click="uploadPincodeDetails"
                      >
                        Upload
                      </v-btn>
                      <!-- <v-btn
                            color="info"
                            class="mt-3 ml-3"
                            :loading="downloader"
                            @click="downloadPincodeDetails()"
                            >Download template</v-btn
                          > -->
                      <v-btn class="mt-3 ml-3" @click="close"> Cancel </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-btn
            color="primary"
            :loading="fileLoader"
            small
            class="mr-2 mt-2"
            @click="dialog = true"
            v-if="
              selectedCountryId && checkPermission('app_base:pincode-upload')
            "
            >Upload</v-btn
          >
          <v-btn
            color="info"
            small
            :loading="downloader"
            @click="downloadDetails()"
            class="mr-4 mt-2"
            v-if="
              selectedCountryId && checkPermission('app_base:pincode-download')
            "
            >Download</v-btn
          >
        </div>
        <v-select
          v-model="selectedCountryId"
          label="Country"
          class="pt-0 pb-0"
          item-text="name"
          item-value="id"
          :items="countries"
          dense
          outlined
          hide-details
          @change="fetchList(selectedCountryId)"
        ></v-select>
      </v-col>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="pincodeList"
      :options.sync="options"
      :loading="pincodeLoader"
      class="elevation-1"
      :items-per-page="100"
      :footer-props="{
        itemsPerPageOptions: [100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <div class="custom-row p-5">
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Pincode"
                  v-model="PinCodeValue"
                  outlined
                  clearable
                  @click:clear="PinCodeValue = ''"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="offset-md-6">
                <v-btn color="white" @click="clearAll" style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-5"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </div>
          </v-form>
        </template>
        <v-divider class="mt-2 mb-2"></v-divider>
      </template>
    </v-data-table>
    <BulkErrors
      :dialog="uploadResDialog"
      :data="uploadRes"
      @close="uploadResDialog = false"
    />
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
import BulkErrors from "@/components/front/common/BulkErrors";

export default {
  components: { BulkErrors },
  created() {
    if (this.$route.params.id !== undefined)
      this.selectedCountryId = this.$route.params.id;
    this.fetchList(this.$route.params.id);
    this.getCountryList();
  },
  data() {
    return {
      PinCodeValue: "",
      uploadResDialog: false,
      dialog: false,
      dialogConfirm: false,
      pincodeLoader: false,
      options: {},
      downloader: false,
      pincodeList: [],
      countries: [],
      selectedCountryId: "",
      name: "",
      filtersArr: {},
      headers: [
        {
          text: "Code",
          value: "pincode",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        this.fetchList();
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions([
      "snackBar",
      "getCountries",
      "getPincodeList",
      "downloadPincodeSetting",
      "uploadPincode",
    ]),
    allFilters() {
      this.orderLoader = true;
      let obj = {
        pincode: this.PinCodeValue,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    clearAll() {
      this.PinCodeValue = "";
      this.searchAll();
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.fetchList(this.selectedCountryId);
    },
    fetchList(id) {
      if (id !== undefined) {
        this.pincodeLoader = true;
        let payload = {
          ...this.options,
          id,
          ...this.filtersArr,
        };
        this.getPincodeList(payload)
          .then((res) => {
            this.pincodeList = res.data.records;
            this.pincodeLoader = false;
          })
          .catch(() => {
            this.pincodeLoader = false;
          });
      }
    },
    getCountryList() {
      this.getCountries().then((res) => {
        this.countries = res.data;
      });
    },
    uploadPincodeDetails() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.file);
      payload.append("country_id", this.selectedCountryId);
      this.uploadPincode(payload)
        .then((res) => {
          this.fileLoader = false;
          this.dialog = false;
          this.uploadRes = res.data;
          this.uploadResDialog = true;
          this.fetchList(this.selectedCountryId);
        })
        .catch(() => {
          this.fileLoader = false;
        });
    },

    downloadDetails() {
      this.downloader = true;
      const payload = new FormData();
      payload.append("country_id", this.selectedCountryId);
      this.downloadPincodeSetting(payload)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    close() {
      this.dialog = false;
      this.$refs.form?.reset();
    },
  },
};
</script>
<style scoped>
.file-padding {
  padding-right: 72px;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 5px 5px 5px !important;
}
.v-select:not(.v-text-field--single-line):not(.v-text-field--outlined)
  .v-select__slot
  > input {
  align-self: flex-end;
}
</style>
